(() => {
    const artifactsUrl = '/service/memories/manager/artifacts/'
    const getTagsParam = 'includeTags=true'

    function getArtifact(id) {
        return FS.fetch(`${artifactsUrl}${id}?${getTagsParam}`)
    }

    window.Home = window.Home || {}
    Home.Artifacts = {
        getArtifact
    }
  })()

